import { Root } from '@radix-ui/react-accordion'

export const Accordion = Root
